
import { Link } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';

export default function CustomerPrivacy() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-50 to-white">
      <Navbar />

      <div className="container mx-auto px-6 py-16">
        <div className="max-w-4xl mx-auto">
          <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-8">
            <h1 className="text-4xl font-bold text-gray-800 mb-8">Customer Privacy Policy</h1>
            
            <div className="text-gray-600 space-y-8">
              <div>
                <p className="text-sm text-gray-500 mb-4">Last updated: January 2024</p>
                <p className="text-lg mb-4">
                  At Baainearme (BNM), we are committed to protecting your privacy and ensuring the security of your personal information. This Privacy Policy explains how we collect, use, and protect your data when you use our customer services.
                </p>
              </div>

              <section>
                <h2 className="text-2xl font-bold text-gray-800 mb-4">Information We Collect</h2>
                <div className="space-y-4">
                  <div>
                    <h3 className="text-lg font-semibold text-gray-800 mb-2">Personal Information</h3>
                    <ul className="list-disc list-inside space-y-1 text-gray-600">
                      <li>Name, email address, and phone number</li>
                      <li>Delivery address and location data</li>
                      <li>Payment information (processed securely)</li>
                      <li>Profile preferences and service history</li>
                    </ul>
                  </div>
                  
                  <div>
                    <h3 className="text-lg font-semibold text-gray-800 mb-2">Usage Information</h3>
                    <ul className="list-disc list-inside space-y-1 text-gray-600">
                      <li>App usage patterns and preferences</li>
                      <li>Service ratings and reviews</li>
                      <li>Communication with customer support</li>
                      <li>Device information and IP address</li>
                    </ul>
                  </div>
                </div>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-gray-800 mb-4">How We Use Your Information</h2>
                <ul className="list-disc list-inside space-y-2 text-gray-600">
                  <li>To provide and improve our home services</li>
                  <li>To match you with appropriate service partners</li>
                  <li>To process payments and handle billing</li>
                  <li>To send service updates and notifications</li>
                  <li>To provide customer support</li>
                  <li>To enhance app functionality and user experience</li>
                </ul>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-gray-800 mb-4">Information Sharing</h2>
                <div className="space-y-4">
                  <p>We only share your information in the following circumstances:</p>
                  <ul className="list-disc list-inside space-y-2 text-gray-600">
                    <li><strong>Service Partners:</strong> We share necessary contact and location details with assigned service partners to complete your bookings</li>
                    <li><strong>Payment Processors:</strong> Payment information is shared with secure payment gateways for transaction processing</li>
                    <li><strong>Legal Requirements:</strong> When required by law or to protect our rights and safety</li>
                    <li><strong>Business Transfers:</strong> In case of merger, acquisition, or sale of our business</li>
                  </ul>
                </div>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-gray-800 mb-4">Data Security</h2>
                <div className="space-y-4">
                  <p>We implement industry-standard security measures to protect your data:</p>
                  <ul className="list-disc list-inside space-y-2 text-gray-600">
                    <li>Encryption of sensitive data in transit and at rest</li>
                    <li>Regular security audits and updates</li>
                    <li>Restricted access to personal information</li>
                    <li>Secure payment processing systems</li>
                  </ul>
                </div>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-gray-800 mb-4">Your Rights</h2>
                <p className="mb-4">As a customer, you have the following rights:</p>
                <ul className="list-disc list-inside space-y-2 text-gray-600">
                  <li><strong>Access:</strong> Request access to your personal data</li>
                  <li><strong>Correction:</strong> Update or correct inaccurate information</li>
                  <li><strong>Deletion:</strong> Request deletion of your account and data</li>
                  <li><strong>Portability:</strong> Request a copy of your data in a portable format</li>
                  <li><strong>Opt-out:</strong> Unsubscribe from marketing communications</li>
                </ul>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-gray-800 mb-4">Cookies and Tracking</h2>
                <p className="mb-4">We use cookies and similar technologies to:</p>
                <ul className="list-disc list-inside space-y-2 text-gray-600">
                  <li>Remember your preferences and settings</li>
                  <li>Analyze app usage and improve performance</li>
                  <li>Provide personalized service recommendations</li>
                  <li>Ensure security and prevent fraud</li>
                </ul>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-gray-800 mb-4">Contact Us</h2>
                <p className="mb-4">If you have questions about this Privacy Policy or your data, contact us:</p>
                <div className="bg-purple-50 rounded-lg p-6">
                  <div className="space-y-2">
                    <p><strong>Email:</strong> privacy@baainearme.com</p>
                    <p><strong>Phone:</strong> 93074 19845</p>
                    <p><strong>Address:</strong> BNM Headquarters, Nagpur, Maharashtra, India</p>
                  </div>
                </div>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-gray-800 mb-4">Changes to This Policy</h2>
                <p>
                  We may update this Privacy Policy from time to time. We will notify you of any significant changes by email or through the app. Your continued use of our services after such changes constitutes acceptance of the updated policy.
                </p>
              </section>
            </div>
          </div>
        </div>
      </div>

      {/* Footer */}
      <footer className="bg-gray-800 text-white py-12">
        <div className="container mx-auto px-6">
          <div className="grid md:grid-cols-4 gap-8">
            <div>
              {/* BNM logo (SVG) — scalable, color via currentColor */}
<svg
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 420 160"
  className="h-10 text-white"   // change to text-purple-600 etc.
  role="img"
  aria-label="BNM · Baainearme"
>
  <g fill="none" stroke="currentColor" strokeWidth="12" strokeLinecap="round">
    {/* Left ring */}
    <circle cx="50" cy="60" r="40" />
    {/* Vertical divider */}
    <line x1="110" y1="20" x2="110" y2="120" />
  </g>

  {/* Text block */}
  <g fill="currentColor">
    {/* BNM */}
    <text
      x="140"
      y="72"
      fontFamily="Poppins, Inter, Arial, sans-serif"
      fontWeight="800"
      fontSize="56"
    >
      BNM
    </text>

    {/* Baainearme */}
    <text
      x="140"
      y="120"
      fontFamily="Poppins, Inter, Arial, sans-serif"
      fontWeight="700"
      fontSize="32"
    >
      Baainearme
    </text>
  </g>
</svg>

              <p className="text-gray-400">
                Your trusted platform for on-demand home services
              </p>
            </div>

            <div>
              <h3 className="text-lg font-semibold mb-4">For Customers</h3>
              <ul className="space-y-2 text-gray-400">
                <li><Link to="/customer" className="hover:text-white cursor-pointer">Book Services</Link></li>
                <li><Link to="/customer-privacy" className="hover:text-white cursor-pointer">Privacy Policy</Link></li>
                <li><Link to="/customer-terms" className="hover:text-white cursor-pointer">Terms & Conditions</Link></li>
              </ul>
            </div>

            <div>
              <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
              <ul className="space-y-2 text-gray-400">
                <li><Link to="/partner" className="hover:text-white cursor-pointer">Become Partner</Link></li>
                <li><Link to="/about" className="hover:text-white cursor-pointer">About Us</Link></li>
                <li><Link to="/refund-policy" className="hover:text-white cursor-pointer">Refund Policy</Link></li>
              </ul>
            </div>

            <div>
              <h3 className="text-lg font-semibold mb-4">Support</h3>
              <ul className="space-y-2 text-gray-400">
                <li>📞 93074 19845</li>
                <li>✉ support@baainearme.com</li>
                <li><a href="#" className="hover:text-white cursor-pointer">Help Center</a></li>
              </ul>
            </div>
          </div>

          <div className="border-t border-gray-700 mt-8 pt-8 text-center text-gray-400">
            <p>&copy; 2024 Baainearme. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </div>
  );
}
